import { createVNode as _createVNode, isVNode as _isVNode, mergeProps as _mergeProps } from "vue";
import { defineComponent, getCurrentInstance } from 'vue';
import { MenuItem as AntMenuItem } from 'ant-design-vue';
import { menuItemProps as antMenuItemProps } from 'ant-design-vue/es/menu/src/MenuItem';
import Wrapper from '../wrapper';
import { commonProps } from '../utils';
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
const elfMenuItemProps = {
  ...commonProps
}; // 这里的as const可以防止在.d.ts中将required:true生成required:boolean，这样的话，可以保证组件prop的required可以被成功校验

const menuItemProps = {
  ...antMenuItemProps(),
  ...elfMenuItemProps
};
const MenuItem = defineComponent({
  name: 'ElfMenuItem',
  props: menuItemProps,
  setup(props, {
    attrs,
    slots
  }) {
    const key = getCurrentInstance()?.vnode.key;
    return () => _createVNode(Wrapper, null, {
      default: () => [_createVNode(AntMenuItem, _mergeProps({
        "key": key
      }, props, attrs), _isSlot(slots) ? slots : {
        default: () => [slots]
      })]
    });
  }
});
export default MenuItem;